import cx from 'classnames'

type ContactLike = {
  firstName: string | null
  lastName: string | null
  phoneNumber: string | null
  emailAddress: string | null
}

type Props = {
  contact: ContactLike
  className?: string
}

export const ContactInfo = ({contact, className}: Props) => {
  return (
    <div className={cx('flex flex-col text-[#2F4B5F]', className)}>
      <div>
        {contact.firstName} {contact.lastName}
      </div>
      <div>{contact.phoneNumber}</div>
      <div>{contact.emailAddress}</div>
    </div>
  )
}
